import LoadingComponent from "components/LoadingComponent";
import DashboardLayout from "features/LayoutContainers/DashboardLayout";
import DashboardNavbar from "features/Navbars/DashboardNavbar";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllPromotions,
  getPromotionThunk
} from "redux/slices/notificationSlice";
import WithAuthWrapper from "withWrapper/withAuthWrapper";
import PromotionModal from "./PromotionModal";
import PromotionTable from "./table";
import { Alert, Snackbar } from "@mui/material";
import { Promotion } from "types/Promotion";

const headers = [
  { id: "id", name: "Id" },
  { id: "title", name: "Title" },
  { id: "subtitle", name: "Subtitle" },
  { id: "created_at", name: "Created At" },
  { id: "actions", name: "Actions" }
];
const PromotionPage: React.FC = () => {
  const accessToken = localStorage.getItem("stmpz-token");
  const businessId = localStorage.getItem("stmpz-business-id") || "";
  const dispatch = useDispatch();
  const promotions = useSelector(getAllPromotions);
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [openSnackBar, setOpenSnackBar] = React.useState(false);
  const [selectedPromotion, setSelectedPromotion] = useState<Promotion>();
  const [isEdit, setIsEdit] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);

  const getPromotionPage = useCallback(
    (page: number) => {
      if (accessToken) {
        dispatch(getPromotionThunk({ accessToken, businessId }));
      }
    },
    [accessToken, businessId, dispatch]
  );
  useEffect(() => {
    if (accessToken && !hasFetched) {
      setHasFetched(true);
      getPromotionPage(1);
    }
  }, [accessToken, getPromotionPage, hasFetched]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PromotionModal
        open={isModalOpen}
        isEdit={isEdit}
        handleClose={(refreshed?: boolean) => {
          if (refreshed) {
            getPromotionPage(1);
          }
          setModalOpen(false);
        }}
        selectedPromotion={selectedPromotion}
        addPromotion={(name: string) => {
          setIsEdit(false);
          setSelectedPromotion(undefined);
          setModalOpen(false);
        }}
      />
      <Snackbar
        open={openSnackBar}
        autoHideDuration={5000}
        onClose={() => setOpenSnackBar(false)}
        message="This Snackbar will be dismissed in 5 seconds."
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpenSnackBar(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Promotion has created successfully!!
        </Alert>
      </Snackbar>
      {!!promotions ? (
        <PromotionTable
          header={headers}
          rows={promotions}
          onPageChanged={(newPage: number) => getPromotionPage(newPage + 1)}
          onReload={() => getPromotionPage(1)}
          addPromotion={(isEdit: boolean, promotion?: Promotion) => {
            setSelectedPromotion(promotion);
            setIsEdit(isEdit);
            setModalOpen(true);
          }}
        />
      ) : (
        <LoadingComponent />
      )}
    </DashboardLayout>
  );
};

export default WithAuthWrapper(PromotionPage);
